import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { jsx as ___EmotionJSX } from "@emotion/core";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import React, { useState } from 'react';
import { css } from '@emotion/core';
import { Button, Banner, ButtonStack, TextField } from '@dfds-ui/react-components';
import { Text } from '@dfds-ui/typography';
import BackButton from '../../../common/components/BackButton';
import Container from '../../../common/components/Container';
import StepNavigation from './StepNavigation';
import FlowScreenHeader from './FlowScreenHeader';
import { validateEmailBackend } from '../utils';
import { useAuth } from '../useAuth';
import { useTrans } from '../../../localization/i18n';

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1uvakbc",
  styles: "max-width:270px;"
} : {
  name: "1uvakbc",
  styles: "max-width:270px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var ForgotPasswordEmail = function ForgotPasswordEmail(_ref2) {
  var className = _ref2.className,
      onStepChange = _ref2.onStepChange;

  var _useState = useState({
    submitting: false,
    email: '',
    error: '',
    fieldErrors: {},
    disabled: true
  }),
      _useState2 = _slicedToArray(_useState, 2),
      formState = _useState2[0],
      setFormState = _useState2[1];

  var _useAuth = useAuth(),
      authApi = _useAuth.authApi;

  var _useTrans = useTrans('common'),
      t = _useTrans.t;

  var sendResetEmail =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(event) {
      var newState, isValidEmail, transaction;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              newState = {
                submitting: true,
                fieldErrors: {}
              };
              event.preventDefault();
              setFormState(_objectSpread({}, formState, {}, newState));

              if (!(formState.email.length < 1)) {
                _context.next = 8;
                break;
              }

              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              newState.fieldErrors.email = 'Field cannot be empty';
              newState.submitting = false;
              setFormState(_objectSpread({}, formState, {}, newState));
              return _context.abrupt("return");

            case 8:
              _context.next = 10;
              return validateEmailBackend(formState.email);

            case 10:
              isValidEmail = _context.sent;

              if (isValidEmail) {
                _context.next = 16;
                break;
              }

              newState.fieldErrors = {
                email: "Email doesn't look quite right"
              };
              newState.submitting = false;
              setFormState(_objectSpread({}, formState, {}, newState));
              return _context.abrupt("return");

            case 16:
              _context.next = 18;
              return authApi.forgotPassword(formState.email);

            case 18:
              transaction = _context.sent;

              if (transaction.status !== 'RECOVERY_CHALLENGE') {
                newState.error = t('error_generic', 'Something went wrong');
                newState.submitting = false;
                setFormState(_objectSpread({}, formState, {}, newState));
              } else {
                if (onStepChange) {
                  onStepChange('next');
                }
              }

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function sendResetEmail(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(Container, null, ___EmotionJSX(StepNavigation, null, ___EmotionJSX(BackButton, {
    onClick: function onClick() {
      onStepChange && onStepChange('prev');
    }
  })), ___EmotionJSX("form", {
    onSubmit: sendResetEmail
  }, ___EmotionJSX(FlowScreenHeader, {
    content: t('forgot_passowrd_label', 'Forgot password')
  }), ___EmotionJSX("div", {
    className: className
  }, ___EmotionJSX(TextField, {
    name: "email",
    label: t('forgot_password_field_label', 'Send reset-email to:'),
    errorMessage: formState.fieldErrors.email,
    onChange: function onChange(event) {
      var disabled = event.target.value.length < 1;
      setFormState(_objectSpread({}, formState, {
        email: event.target.value,
        disabled: disabled
      }));
    }
  }), ___EmotionJSX(ButtonStack, {
    orientation: "vertical"
  }, ___EmotionJSX(Button, {
    "data-testid": "send-email-button",
    variation: "primary",
    disabled: formState.disabled,
    submitting: formState.submitting
  }, t('forgot_password_email_button_label', 'Send reset-email'))), ___EmotionJSX(Text, {
    styledAs: "body",
    css: _ref
  }, t('forgot_password_email_help_text', 'Type in your email and we will send you a mail with a verification code.'))), formState.error && formState.error.length > 0 && ___EmotionJSX(Banner, {
    intent: "critical"
  }, formState.error)));
};

export default ForgotPasswordEmail;